import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";

import git from "../../assets/Images/git.png";
import code from "../../assets/Images/code.png";


import "./LO.css"; // Import the CSS file

const LO2 = () => {
    const navigate = useNavigate();

    const cardslo2 = [
        {
            title: "Git Repository",
            description: "",
            image: git,
            path: '/lo2/git'
        },

        // {
        //     title: "Read me Git",
        //     description: "",
        //     image: "",
        //     path: '/readgit'
        // },

        // {
        //     title: "Commits & Branches",
        //     description: "",
        //     image: "",
        //     path: '/commitandbranches'
        // },

        {
            title: "Code Documentation",
            description: "",
            image: code,
            path: '/lo2/codedocumentation'
        },



        
        
    ];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo2-headings">
                <h1>Transferable Production</h1>
                {/* <p></p> */}

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                            <BreadcrumbHeader />
            </div>
            <div className="content-lo2">
                <div className="content-lo2-card-container">
                    {cardslo2.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-lo2" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-lo2-image" />
                            <h3 className="card-lo2-title">{title}</h3>
                            <p className="card-lo2-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default LO2;